"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var RecordRTC = require("recordrtc");
var WebRTCRecorder = /** @class */ (function () {
    function WebRTCRecorder(recordRTC) {
        this.recordRTC = recordRTC;
    }
    WebRTCRecorder.instance = function () {
        return this.INSTANCE || (this.INSTANCE = new this(WebRTCRecorder.initializeAudioContext()));
    };
    /**
     * Starts the RecordRTC recording
     */
    WebRTCRecorder.prototype.startRecording = function () {
        return __awaiter(this, void 0, void 0, function () {
            var r, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.recordRTC];
                    case 1:
                        r = _a.sent();
                        r.startRecording();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error("could not initialize audio context: " + e_1.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Stops the recording session and transforms the resulting blob to base64 encoded string
     */
    WebRTCRecorder.prototype.stopRecording = function () {
        return __awaiter(this, void 0, void 0, function () {
            var recorder, reader, _a, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.recordRTC];
                    case 1:
                        recorder = _c.sent();
                        return [4 /*yield*/, recorder.stopRecording()];
                    case 2:
                        _c.sent();
                        reader = new FileReader();
                        _b = (_a = reader).readAsDataURL;
                        return [4 /*yield*/, recorder.getBlob()];
                    case 3:
                        _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                reader.onloadend = function () {
                                    _this.recordRTC = WebRTCRecorder.initializeAudioContext();
                                    resolve(WebRTCRecorder.removeMimeType(reader.result));
                                };
                                reader.onerror = function () { return reject(new Error("could not transform recorded data to base64")); };
                            })];
                }
            });
        });
    };
    /**
     * Initializes the browser audio context
     */
    WebRTCRecorder.initializeAudioContext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stream, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({ audio: true, video: false })];
                    case 1:
                        stream = _a.sent();
                        return [2 /*return*/, new RecordRTC.RecordRTCPromisesHandler(stream, WebRTCRecorder.rtcConfig())];
                    case 2:
                        e_2 = _a.sent();
                        throw new Error("could not initialize audio context: " + e_2.message);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes the: 'data:[<mediatype>][;base64],' part from the given url string
     * @param dataUrl
     */
    WebRTCRecorder.removeMimeType = function (dataUrl) {
        var split = dataUrl.split(",");
        if (split.length < 2) {
            throw new Error("received invalid data url");
        }
        return dataUrl.split(",")[1];
    };
    /**
     * RecordRTC audio recording configuration
     * @see https://recordrtc.org
     */
    WebRTCRecorder.rtcConfig = function () {
        return {
            type: 'audio',
            recorderType: RecordRTC.StereoAudioRecorder,
            mimeType: 'audio/wav',
            desiredSampRate: 16 * 1000,
            numberOfAudioChannels: 1
        };
    };
    return WebRTCRecorder;
}());
exports.WebRTCRecorder = WebRTCRecorder;
